<template>
  <div>
    <div class="sticky-top topNav" style="">
      <div class="container row" style="">
        <div
          class="col pl-1"
          :style="rtl ? 'text-align: right;' : 'text-align: left;'"
        >
          <img
            src="@/assets/kekw.png"
            style="width: 35px; height: 35px"
          /><router-link id="1" to="/Today"
            ><img src="@/assets/zuniLogo.svg" style="width: 90px; height: 20px"
          /></router-link>
        </div>
        <router-link
          id="router-link"
          style="color: whitesmoke"
          :to="{ name: 'Faq' }"
          ><b-button
            style="
              background: #212225;
              border-radius: 2px;
              border: none;
              height: 25px;
              margin-top: 3px;
              line-height: 10px;
              font-size: 12px;
            "
            >FAQ
          </b-button></router-link
        >
        <b-button
          variant="none"
          v-b-modal.modal-search2
          style="margin-right: 5px; margin-top: 2px"
          class="col-1 pr-1"
        >
          <img src="@/assets/search.png" style="width: 18px" alt="" />
        </b-button>
        <div class="col-1 pr-0 mr-0" v-if="cookiesObject.token">
          <img
            src="@/assets/profile.svg"
            v-b-toggle.sidebar-profile
            style="width: 30px; margin-top: 4.5px"
          />
        </div>
        <div class="col-1 pl-0" v-else>
          <img
            src="@/assets/mobile/profileW.svg"
            @click="checkEvina"
            style="width: 35px; margin-top: 4.5px"
          />
        </div>
        <span class="" style="margin-right: 10px; margin-top: 3px">
          <b-modal
            ref="mysearch-modal"
            :modal-class="myclass"
            id="modal-search2"
            hide-footer
            hide-header
          >
            <div
              style="
                background: #212225;
                margin-left: -15px;
                margin-right: -15px;
                margin-top: -15px;
                margin-bottom: 15px;
                height: 50px;
                line-height: 50px;
              "
            >
              <img
                src="@/assets/kekw.png"
                style="width: 35px; height: 35px"
              /><img
                src="@/assets/zuniLogo.svg"
                style="width: 90px; height: 20px"
              />
              <img
                @click="$refs['mysearch-modal'].hide()"
                src="@/assets/delete.png"
                style="
                  width: 10px;
                  float: right;
                  margin-top: 20px;
                  margin-right: 10px;
                "
                alt=""
              />
            </div>
            <div
              class="row"
              style="margin-bottom: 15px; margin-left: 1px; margin-right: 1px"
            >
              <b-form-input
                class="col"
                v-model="message"
                style="
                  border: solid #357439;
                  border-width: 2px;
                  color: #e6e6e6;
                  background: #212225;
                "
                placeholder="Type your search"
              ></b-form-input>
              <b-button
                variant="none"
                @click="searchT(message)"
                style="margin-left: 2px"
                class="col-1 pl-3 pr-3"
              >
                <img
                  src="@/assets/search.png"
                  style="width: 15px; margin-top: -3px"
                  alt=""
                />
              </b-button>
            </div>
            <b-tabs
              v-if="appear"
              content-class="mt-2"
              style="background: #1a1a1d"
              nav-class="cs1"
              active-nav-item-class="cs"
            >
              <b-tab active style="" class="mytab" title-link-class="tab1">
                <template v-slot:title>
                  <p style="margin: 0px; color: lightgrey; font-size: 13px">
                    Teams
                  </p>
                </template>
                <ul
                  v-for="searchr in search"
                  :key="searchr.id"
                  style="
                    list-style-type: none;
                    padding-left: 0px;
                    margin-left: 10px;
                    font-size: 13px;
                  "
                >
                  <li
                    v-if="searchr.type == 'team'"
                    style="border-bottom: 1px solid rgba(169, 169, 169, 0.1)"
                  >
                    <div
                      v-if="cookiesObject.token"
                      @click="hideModal()"
                      style="height: 30px"
                    >
                      <router-link
                        class=""
                        style="color: #e6e6e6"
                        id=""
                        :to="{
                          name: 'teamPagePar',
                          params: { id: searchr.id },
                        }"
                      >
                        <img
                          :src="teamLogo + searchr.id"
                          alt=""
                          style="
                            width: 18px;
                            margin-top: -5px;
                            margin-right: 3px;
                          "
                        />
                        <span style="font-weight: 300">
                          {{ searchr.name }}
                        </span>
                      </router-link>
                    </div>
                    <span
                      class="kek"
                      v-else
                      data-toggle="modal"
                      @click="hideModal()"
                      data-target="#exampleModal"
                      style="cursor: pointer"
                    >
                      {{ searchr.name }}
                    </span>
                  </li>
                </ul>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <p style="margin: 0px; color: lightgrey; font-size: 13px">
                    Tournaments
                  </p>
                </template>
                <ul
                  v-for="searchr in search"
                  :key="searchr.id"
                  style="
                    list-style-type: none;
                    padding-left: 0px;
                    margin-left: 10px;
                    font-size: 13px;
                  "
                >
                  <li
                    v-if="searchr.type == 'tournament'"
                    style="border-bottom: 1px solid rgba(169, 169, 169, 0.1)"
                  >
                    <div
                      v-if="cookiesObject.token"
                      @click="hideModal()"
                      style="height: 30px"
                    >
                      <router-link
                        class=""
                        style="color: #e6e6e6"
                        id="router-link"
                        :to="{
                          name: 'LeaguePageNav',
                          params: { leagueId: searchr.id },
                        }"
                      >
                        <img
                          :src="tournamentLogo + searchr.id"
                          alt=""
                          style="
                            width: 18px;
                            margin-top: -5px;
                            margin-right: 3px;
                          "
                        />
                        <span style="font-weight: 300">
                          {{ searchr.name }}
                        </span>
                      </router-link>
                    </div>
                    <span
                      class="kek"
                      v-else
                      data-toggle="modal"
                      data-target="#exampleModal"
                      style="cursor: pointer"
                    >
                      {{ searchr.name }}
                    </span>
                  </li>
                </ul>
              </b-tab>
            </b-tabs>
          </b-modal>
        </span>
      </div>
    </div>
    <div>
      <b-sidebar id="sidebar-1" title="">
        <div class="px-3 py-0">
          <ul style="list-style-type: none">
            <li v-if="!cookiesObject.token">
              <div>
                <b-modal
                  :modal-class="myclass"
                  id="modal-multi-1"
                  ref="modal-multi-1"
                  size="lg"
                  title="First Modal"
                  hide-header
                  hide-footer
                  no-stacking
                >
                  <p>Zunisport</p>
                  <br />
                  <VuePhoneNumberInput
                    dark
                    v-model="number"
                    @update="onUpdate"
                    maxlength="13"
                    style="margin-bottom: 8px"
                    :default-country-code="forNumInput"
                  />
                  <b-button
                    variant="none"
                    v-on:click="numberCookie(), regSign()"
                    style="width: 100%; background: #1b5e20; color: #e6e6e6"
                    >{{ $t("LanguageEn.txtNext") }}</b-button
                  >
                </b-modal>
                <b-modal
                  ref="regText-modal2"
                  header-class="webOtp"
                  body-class="webOtp1"
                  style=""
                  hide-footer
                  title="Zunisport"
                >
                  <p v-if="introText.code == 200" style="color: #e6e6e6">
                    {{ introText.page.text }}
                  </p>
                  <b-row>
                    <b-col>
                      <button
                        type="submit"
                        class="btn mbtn btn-default btn-block"
                        style="z-index: 0; background: none; color: #ff324d"
                        @click="$refs['regText-modal2'].hide()"
                      >
                        {{ $t("LanguageEn.can") }}
                      </button>
                    </b-col>
                    <b-col>
                      <button
                        type="submit"
                        class="btn btn-default btn-block"
                        style="z-index: 0; background: none; color: #228c39"
                        @click="
                          $refs['regText-modal2'].hide(),
                            $refs['otp-modal2'].show()
                        "
                      >
                        {{ $t("LanguageEn.reg") }}
                      </button>
                    </b-col>
                  </b-row>
                </b-modal>
                <b-modal
                  :modal-class="myclass"
                  ref="otp-modal2"
                  id="modal-multi-2"
                  title="Second Modal"
                  hide-header
                  hide-footer
                >
                  <input
                    type="phone"
                    style="
                      background: #212225;
                      border-radius: 1px;
                      border-color: #2c2d31;
                      color: white;
                    "
                    class="form-control col"
                    maxlength="5"
                    id="exampleFormControlInput1"
                    :placeholder="$t('LanguageEn.pinText')"
                    v-model="OTP"
                  /><br />
                  <b-button
                    v-b-modal.modal-multi-3
                    size="sm"
                    variant="none"
                    style="width: 100%; background: #1b5e20; color: #e6e6e6"
                    v-on:click="verify()"
                    >{{ $t("LanguageEn.txtSubmit") }}</b-button
                  >
                </b-modal>
              </div>
            </li>
          </ul>
          <!-- disabld sidebar -->

          <!-- <div style="">          
          <div>
          <b-modal id="modal-1" :title="$t('LanguageEn.txtLanguage')" hide-footer >
            <p class="my-4" v-for="language in languages" :key="language.id" @click="changeLang(language.code, language.id)" style="cursor: pointer;"> <span v-bind:class="{selectedLang: cookiesObject.lang == language.code}">{{language.name}}</span></p>
          </b-modal>
        </div>
        <div>
          <p style="color: #E6E6E6; font-size: 12px; margin-left: 5px; margin-top: 15px;">Search</p>
            <div class="row" style="margin-bottom: 15px; margin-left: 2px; margin-right: 0px;">
                  <b-form-input class="col" v-model="message" placeholder="Type your search here" @keyup.enter="searchT(message)" style="border: solid #357439; border-width: 2px; color: white; background: #212225;"></b-form-input>
                 
                  </div>
          <b-button v-b-modal.modal-about variant="none" style="border: none; color: #E6E6E6; font-size: 12px;"> {{ $t('LanguageEn.txtAbout') }}</b-button>
          <b-modal id="modal-about" :title="$t('LanguageEn.txtAbout')" hide-footer style="text-align: center !important;" >
            <p class="my-4">
              {{about}}
            </p>
          </b-modal>
        </div>
        <div>
          <b-button v-b-modal.modal-terms variant="none" style="border: none; color: #E6E6E6; font-size: 12px"> {{ $t('LanguageEn.txtTermsAndConditions') }}</b-button>
          <b-modal id="modal-terms" :title="$t('LanguageEn.txtTermsAndConditions')" hide-footer >
            <p class="my-4">
              {{terms}}
            </p>
          </b-modal>
        </div>

        </div> -->

          <div></div>
        </div>
      </b-sidebar>
      <b-sidebar id="sidebar-profile" text-variant="light" shadow>
        <template v-slot:title>
          <p style="height: 20px; line-height: 40px">
            <img
              style="width: 30px; margin-bottom: 3px"
              src="@/assets/profile.svg"
            />
            <span style="margin-left: 5px">{{ cookiesObject.number }}</span>
          </p>
        </template>
        <!-- make link and everything here -->
        <div
          class="px-2 py-5"
          :style="
            rtl
              ? 'margin-top: -5px; text-align: right;'
              : 'margin-top: -5px; text-align: left;'
          "
        >
          <p
            class="col"
            style="
              background: #27292c;
              height: 40px;
              line-height: 40px;
              border-radius: 2px;
              margin-bottom: 10px;
            "
          >
            <img
              src="@/assets/wallet.svg"
              style="width: 20px; margin-right: 10px"
              alt=""
            />{{ $t("LanguageEn.balance") }}: {{ balance }}
          </p>
          <p
            class="col"
            style="
              background: #27292c;
              height: 40px;
              line-height: 40px;
              border-radius: 2px;
              margin-bottom: 10px;
            "
          >
            <router-link
              style="text-decoration: none; color: #e6e6e6"
              :to="{ name: 'PredictionsList', params: {} }"
            >
              <img
                style="width: 20px; margin-right: 10px"
                src="@/assets/guessBig.svg"
              />{{ $t("LanguageEn.myGuesses") }}
            </router-link>
          </p>
          <p
            class="col"
            style="
              background: #27292c;
              height: 40px;
              line-height: 40px;
              border-radius: 2px;
              margin-bottom: 10px;
            "
          >
            <router-link
              style="text-decoration: none; color: #e6e6e6"
              :to="{ name: 'Leaderboard', params: {} }"
            >
              <img
                style="width: 20px; margin-right: 10px"
                src="@/assets/leadercup.svg"
              />
              {{ $t("LanguageEn.leaderboard") }}
            </router-link>
          </p>
          <b-dropdown
            id="dropdown-1"
            style="background: #27292c; border-radius: 2px; margin-bottom: 10px"
            block
            variant="none"
            no-caret
            class="m-md-2 b3"
          >
            <template #button-content>
              <div v-if="cookiesObject.token" style="text-align: left">
                <img
                  src="@/assets/uk.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-if="selLanguage.code == 'en'"
                />
                <img
                  src="@/assets/russia.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="selLanguage.code == 'ru'"
                />
                <img
                  src="@/assets/azerbaijan.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="selLanguage.code == 'aze'"
                />
                <img
                  src="@/assets/georgia.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="selLanguage.code == 'ka'"
                />
                <img
                  src="@/assets/arab.png"
                  style="
                    width: 25px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="selLanguage.code == 'ar'"
                />
                <img
                  src="@/assets/france.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="selLanguage.code == 'fr'"
                />
                <img
                  src="@/assets/flag.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else
                />
                <span style="color: lightgrey; font-size: 14px"
                  >{{ selLanguage.code }}
                  <img
                    src="@/assets/ardown.png"
                    style="width: 10px; margin-bottom: 2px; margin-left: 80%"
                    alt=""
                /></span>
              </div>
              <div v-else>
                <img
                  src="@/assets/uk.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-if="cookiesObject.lang == 'en'"
                />
                <img
                  src="@/assets/russia.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="cookiesObject.lang == 'ru'"
                />
                <img
                  src="@/assets/azerbaijan.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="cookiesObject.lang == 'aze'"
                />
                <img
                  src="@/assets/georgia.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="cookiesObject.lang == 'ka'"
                />
                <img
                  src="@/assets/france.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="cookiesObject.lang == 'fr'"
                />
                <img
                  src="@/assets/arab.png"
                  style="
                    width: 25px;
                    margin-right: 5px;
                    margin-left: -5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="cookiesObject.lang == 'ar'"
                />
                <img
                  src="@/assets/flag.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else
                />
                <span style="color: lightgrey; font-size: 14px"
                  >{{ cookiesObject.lang }}
                  <img
                    src="@/assets/ardown.png"
                    style="width: 10px; margin-left: 7px; margin-bottom: 2px"
                    alt=""
                /></span>
              </div>
            </template>
            <b-dropdown-item
              v-for="language in languages"
              :key="language.id"
              @click="changeLang(language.code, language.id)"
            >
              <img
                src="@/assets/uk.png"
                style="width: 15px; margin-right: 5px; margin-bottom: 2px"
                alt=""
                v-if="language.code == 'en'"
              />
              <img
                src="@/assets/arab.png"
                style="
                  width: 25px;
                  margin-right: 5px;
                  margin-left: -5px;
                  margin-bottom: 2px;
                "
                alt=""
                v-else-if="language.code == 'ar'"
              />
              <img
                src="@/assets/russia.png"
                style="width: 15px; margin-right: 5px; margin-bottom: 2px"
                alt=""
                v-else-if="language.code == 'ru'"
              />
              <img
                src="@/assets/azerbaijan.png"
                style="width: 15px; margin-right: 5px; margin-bottom: 2px"
                alt=""
                v-else-if="language.code == 'aze'"
              />
              <img
                src="@/assets/georgia.png"
                style="width: 15px; margin-right: 5px; margin-bottom: 2px"
                alt=""
                v-else-if="language.code == 'ka'"
              />
              <img
                src="@/assets/france.png"
                style="width: 15px; margin-right: 5px; margin-bottom: 2px"
                alt=""
                v-else-if="language.code == 'fr'"
              />
              <img
                src="@/assets/flag.png"
                style="width: 15px; margin-right: 5px; margin-bottom: 2px"
                alt=""
                v-else
              />
              <span style="color: lightgrey; font-size: 14px">
                {{ language.name }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
          <p
            class="col"
            v-on:click="logout()"
            style="
              background: #27292c;
              height: 40px;
              line-height: 40px;
              border-radius: 2px;
              margin-bottom: 10px;
            "
          >
            <img
              style="width: 20px; margin-right: 10px"
              src="@/assets/logoutN.svg"
            />
            {{ $t("LanguageEn.logout") }}
          </p>
        </div>
      </b-sidebar>
    </div>
    <div
      class="container"
      v-if="
        $route.name == 'Today' ||
        $route.name == 'Live' ||
        $route.name == 'Finished'
      "
    >
      <div class="row" id="" style="background: #1b5e20">
        <!-- <li class="nav-item ">
                    <router-link  style="border-top-left-radius: 5px;" id="routerLink1" to="/Live">{{ $t('LanguageEn.tabLive') }}</router-link> 
                  </li> -->
        <div class="col" style="padding-top: 3px">
          <router-link
            id="routerLink1"
            class="routerLink1"
            style="font-size: 12px"
            :to="{ name: 'Finished', params: { dateS: getDate4() } }"
            >{{ date1.split(" ")[0] }} <br />
            {{ date1.split(" ")[1] }}</router-link
          >
        </div>
        <div class="col" style="padding-top: 3px">
          <router-link
            id="routerLink1"
            class="routerLink1"
            style="font-size: 12px"
            :to="{ name: 'Finished', params: { dateS: getDate2() } }"
            >{{ date2.split(" ")[0] }} <br />
            {{ date2.split(" ")[1] }}</router-link
          >
        </div>
        <div class="col" style="padding-top: 3px">
          <router-link
            class="active routerLink1"
            style="font-size: 12px"
            id="routerLink1"
            :to="{ name: 'Today' }"
            >{{ datenow.split(" ")[0] }} <br />
            {{ datenow.split(" ")[1] }}</router-link
          >
        </div>
        <div class="col" style="padding-top: 3px">
          <router-link
            id="routerLink1"
            class="routerLink1"
            style="font-size: 12px"
            :to="{ name: 'Finished', params: { dateS: getDate1() } }"
            >{{ date3.split(" ")[0] }} <br />
            {{ date3.split(" ")[1] }}</router-link
          >
        </div>
        <div class="col" style="padding-top: 3px">
          <router-link
            id="routerLink1"
            class="routerLink1"
            style="font-size: 12px"
            :to="{ name: 'Finished', params: { dateS: getDate3() } }"
            >{{ date4.split(" ")[0] }} <br />
            {{ date4.split(" ")[1] }}</router-link
          >
        </div>
        <div
          class="col"
          style="background: none; border: none; color: white !important"
          v-on:click="(dateIden = value), setLIDs()"
        >
          <b-form-datepicker
            @input="redirect()"
            button-only
            selected-variant="success"
            button-variant="success"
            today-variant="success"
            placeholder="Today"
            id="example-datepicker"
            right
            size="sm"
            v-model="value"
            class="mb-2"
            style="
              border: none;
              background: none;
              padding-top: 10px;
              border-radius: 0px;
              float: right;
            "
          ></b-form-datepicker>
        </div>
        <!-- <li class="nav-item " v-if="cookiesObject.token">
                    <router-link id="routerLink1" to="/MyGames" style="font-size: 10.5px;">{{ $t('LanguageEn.tabMyGames') }}</router-link> 
                  </li>
                  <li class="nav-item " v-else>
                    <div id="routerLink1" to="/MyGames" style="font-size: 10.5px; cursor: pointer;" data-toggle="modal" data-target="#exampleModal">{{ $t('LanguageEn.tabMyGames') }}</div> 
                  </li> -->
      </div>
    </div>
    <router-view />
    <div class="middleSection"></div>
    <nav class="nav footer fixed-bottom" style="background: #1a1a1d">
      <div class="container">
        <div class="row">
          <div class="col pl-1">
            <router-link
              id="routerLink"
              style="font-size: 11px; color: #e6e6e6"
              :to="{ name: 'Today', params: { value: value } }"
              ><img
                v-if="$route.name == 'Today'"
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/allGames.svg"
              /><img
                v-else
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/allGamesp.svg"
              /><br />
              <span v-if="$route.name == 'Today'" style="color: #43a047">{{
                $t("LanguageEn.tabToday")
              }}</span
              ><span style="color: #e6e6e6" v-else>{{
                $t("LanguageEn.tabToday")
              }}</span>
            </router-link>
          </div>
          <div class="col" v-if="cookiesObject.token">
            <router-link
              id="routerLink"
              style="font-size: 11px; color: #e6e6e6"
              :to="{ name: 'MyGames', params: { value: value } }"
              ><img
                v-if="$route.name == 'MyGames'"
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/favorite.svg"
              /><img
                v-else
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/favoritep.svg"
              /><br /><span
                v-if="$route.name == 'MyGames'"
                style="color: #43a047"
                >{{ $t("LanguageEn.txtFavorite") }}</span
              ><span style="color: #e6e6e6" v-else>{{
                $t("LanguageEn.txtFavorite")
              }}</span></router-link
            >
          </div>
          <div class="col" v-else>
            <div
              id="routerLink"
              style="font-size: 11px; color: #e6e6e6"
              v-b-modal.modal-multi-1
            >
              <img
                v-if="$route.name == 'MyGames'"
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/favorite.svg"
              /><img
                v-else
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/favoritep.svg"
              /><br /><span
                v-if="$route.name == 'MyGames'"
                style="color: #43a047"
                >{{ $t("LanguageEn.txtFavorite") }}</span
              ><span style="color: #e6e6e6" v-else>{{
                $t("LanguageEn.txtFavorite")
              }}</span>
            </div>
          </div>
          <div class="col">
            <router-link
              id="routerLink"
              style="font-size: 11px; color: #e6e6e6"
              :to="{ name: 'Live', params: { value: value } }"
              ><img
                v-if="$route.name == 'Live'"
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/live.svg"
              /><img
                v-else
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/livep.svg"
              /><br /><span
                v-if="$route.name == 'Live'"
                style="color: #43a047"
                >{{ $t("LanguageEn.tabLive") }}</span
              ><span style="color: #e6e6e6" v-else>{{
                $t("LanguageEn.tabLive")
              }}</span></router-link
            >
          </div>
          <div v-if="cookiesObject.token" class="col">
            <router-link
              id="routerLink"
              style="font-size: 11px; color: #e6e6e6"
              :to="{ name: 'PredictionsList', params: {} }"
              ><img
                v-if="$route.name == 'PredictionsList'"
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/guess.svg"
              /><img
                v-else
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/guessp.svg"
              /><br /><span
                v-if="$route.name == 'PredictionsList'"
                style="color: #43a047"
                >{{ $t("LanguageEn.guess") }}</span
              ><span style="color: #e6e6e6" v-else>{{
                $t("LanguageEn.guess")
              }}</span></router-link
            >
          </div>
          <div v-else class="col">
            <div
              id="routerLink"
              style="font-size: 11px; color: #e6e6e6"
              v-b-modal.modal-multi-1
            >
              <img
                v-if="$route.name == 'PredictionsList'"
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/guess.svg"
              /><img
                v-else
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/guessp.svg"
              /><br /><span
                v-if="$route.name == 'PredictionsList'"
                style="color: #43a047"
                >{{ $t("LanguageEn.guess") }}</span
              ><span style="color: #e6e6e6" v-else>{{
                $t("LanguageEn.guess")
              }}</span>
            </div>
          </div>
          <div class="col">
            <router-link
              id="routerLink"
              style="font-size: 11px; color: #e6e6e6"
              to="/Leagues"
              ><img
                v-if="$route.name == 'Leagues'"
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/leagues.svg"
              /><img
                v-else
                style="width: 25px; margin-top: 6px"
                src="@/assets/mobile/leaguesp.svg"
              /><br /><span
                v-if="$route.name == 'Leagues'"
                style="color: #43a047"
                >{{ $t("LanguageEn.txtLeagues") }}</span
              ><span style="color: #e6e6e6" v-else>{{
                $t("LanguageEn.txtLeagues")
              }}</span></router-link
            >
          </div>
        </div>
      </div>
    </nav>

    <b-modal
      ref="error-modal"
      header-class="webOtp"
      body-class="webOtp1"
      size="sm"
      hide-footer
      hide-header
    >
      <p style="text-align: center; color: #e6e6e6; font-size: 13px">
        {{ errorText }}
      </p>
      <b-row>
        <b-col style="text-align: left"> </b-col>
        <b-col style="text-align: right">
          <b-button
            type="submit"
            class="loginButton"
            @click="$refs['error-modal'].hide()"
            style="font-size: 12px"
            variant=""
            >CLOSE</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="regText2-modal"
      title="Register"
      header-class="webOtp"
      body-class="webOtp1"
      style=""
      hide-footer
    >
      <div></div>
      <p
        v-if="introText.code == 200"
        style="margin-top: 10px; color: #e6e6e6"
        v-html="introText.page.text"
      ></p>
      <b-row>
        <b-col>
          <button
            type="submit"
            class="btn btn-default btn-block"
            style="z-index: 0; background: none; color: #228c39"
            @click="$refs['regText2-modal'].hide()"
          >
            {{ $t("LanguageEn.ok") }}
          </button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";

export default {
  name: "MobileNav",
  data() {
    return {
      data: "",
      value: "",
      dateIden: "",
      OTP: "",
      number: "",
      portalLenght: "",
      regOrNot: "",
      token: "",
      clientToken: Date.now() + "_" + this.number,
      username: "",
      cookiesObject: "",
      UserName: "",
      results: {},
      selected: "",
      languages: [],
      terms: "",
      about: "",
      search: "",
      message: "",
      appear: false,
      introText: "",
      forNumInput: "",
      errorText: "",
      date1: "",
      date2: "",
      date3: "",
      date4: "",
      date5: "",
      date6: "",
      datenow: "",
      selLanguage: "",
      myclass: ["myclass"],
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      tournamentLogo: "https://sportapi.zuniac.com/tournament/logo/",
    };
  },
  async created() {
    var res = await fetch(this.httpReq + "/general/appData");
    var data = await res.json();
    this.data = data;
    var portalLenght = data.portals.length;
    this.portalLenght = portalLenght;

    if (data.portals[0].countryCode == "--") {
      this.forNumInput = "US";
    } else {
      this.forNumInput = data.portals[0].countryCode;
    }

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    if (cookiesObject.token) {
      this.getBalance();
    }

    if (cookiesObject.token) {
      const res3 = await fetch(
        this.httpReq + "/general/appData?token=" + this.cookiesObject.token,
        { method: "get" }
      );
      const data3 = await res3.json();
      const languages = data3.portal.languages;
      this.languages = languages;
    } else {
      const res3 = await fetch(
        this.httpReq +
          "/general/appData?portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0),
        { method: "get" }
      );
      const data3 = await res3.json();
      const languages = data3.portal.languages;
      this.languages = languages;
    }
    var myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      this.httpReq +
        "/general/page?languageId=" +
        (this.cookiesObject.langId ? this.cookiesObject.langId : 0) +
        "&link=terms&portalId=" +
        (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0),
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.text) {
          this.terms = result.text;
        } else {
          this.terms = "No information at the moment";
        }
      })
      .catch((error) => console.log("error", error));

    var myHeaders2 = new Headers();
    myHeaders2.append(
      "Cookie",
      "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
    );

    var requestOptions2 = {
      method: "GET",
      headers: myHeaders2,
      redirect: "follow",
    };

    fetch(
      this.httpReq +
        "/general/page?languageId=" +
        (this.cookiesObject.langId ? this.cookiesObject.langId : 0) +
        "&link=about&portalId=" +
        (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0),
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.text) {
          this.about = result.text;
        } else {
          this.about = "No information at the moment";
        }
      })
      .catch((error) => console.log("error", error));

    if (!this.cookiesObject.token) {
      this.$i18n.locale = this.cookiesObject.lang;
    }

    var respons = await fetch(
      this.httpReq +
        "/general/page?languageId=" +
        (this.cookiesObject.langId ? this.cookiesObject.langId : 0) +
        "&link=registration_intro&portalId=" +
        (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0)
    );
    var datafrom = await respons.json();
    this.introText = datafrom;

    // if (this.cookiesObject.lang != '') {
    // this.$i18n.locale = this.cookiesObject.lang;
    // }

    this.getDateNow();

    this.$forceUpdate();
  },

  computed: {
    ...mapGetters(["dateNtime", "lang", "httpReq", "balance", "rtl"]),
    monthNames() {
      return [
        this.$t("LanguageEn.month1"),
        this.$t("LanguageEn.month2"),
        this.$t("LanguageEn.month3"),
        this.$t("LanguageEn.month4"),
        this.$t("LanguageEn.month5"),
        this.$t("LanguageEn.month6"),
        this.$t("LanguageEn.month7"),
        this.$t("LanguageEn.month8"),
        this.$t("LanguageEn.month9"),
        this.$t("LanguageEn.month10"),
        this.$t("LanguageEn.month11"),
        this.$t("LanguageEn.month12"),
      ];
    },
    resultsTable() {
      return Object.keys(this.results);
    },
  },
  methods: {
    ...mapActions(["setdateNtime", "setLang"]),
    checkEvina() {
      //'portal' for evina not 'portalS'

      if (
        this.data.portals[0]?.params.he_enabled == "yes" &&
        this.data.portals[0]?.params.evina_enabled == "1"
      ) {
        this.evinaFlow();
      } else {
        this.$refs["modal-multi-1"].show();
      }
    },

    evinaFlow() {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `http://sportapi.zuniac.com/evina/check?transaction=${localStorage.getItem(
          "transactionId"
        )}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result.code);
          if (result.code == 200) {
            this.heStart();
          } else {
            alert("Error while Evina check");
          }
        })
        .catch((error) => console.log("error", error));
    },

    heStart() {
      console.log(this.cookiesObject.portalId);
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `http://sportapi.zuniac.com/he/start?portalId=${this.cookiesObject.portalId}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          var requestOptions = {
            method: "GET",
            redirect: "follow",
          };

          fetch(result.url, requestOptions)
            .then((response) => response.json())
            .then((result) => {
              this.heEnd(result.transactionId);
            })
            .catch((error) => console.log("error", error));
        })
        .catch((error) => console.log("error", error));
    },
    heEnd(trId) {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `http://sportapi.zuniac.com/he/end?portalId=${
          this.cookiesObject.portalId
        }&trxId=${trId}&clientToken=${Math.random()}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.code == 200) {
            document.cookie =
              "token =" +
              result.token +
              ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

            var appParams = fetch(
              this.httpReq + "/general/appData?token=" + result.token
            );
            var evParams = appParams.json();
            document.cookie =
              "portalId =" +
              evParams.portal.id +
              ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
            document.cookie = "countryCode =" + evParams.portal.countryCode;
            this.reLoad();
          } else {
            this.$refs["modal-multi-1"].show();
          }
        })
        .catch((error) => console.log("error", error));
    },
    getBalance() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq + "/user/me?token=" + this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          this.selLanguage = result.user.language;
        })
        .catch((error) => console.log("error", error));
    },
    getDate1() {
      var dt = new Date();
      dt.setDate(dt.getDate() + 1);
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      this.date3 = dt.getDate() + " " + this.monthNames[fdMonth - 1];

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    getDateNow() {
      var dt = new Date();
      dt.setDate(dt.getDate());
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      this.datenow = dt.getDate() + " " + this.monthNames[fdMonth - 1];

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    getDate3() {
      var dt = new Date();
      dt.setDate(dt.getDate() + 2);
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      this.date4 = dt.getDate() + " " + this.monthNames[fdMonth - 1];

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    getDate2() {
      var dt = new Date();
      dt.setDate(dt.getDate() - 1);
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      this.date2 = dt.getDate() + " " + this.monthNames[fdMonth - 1];

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    getDate4() {
      var dt = new Date();
      dt.setDate(dt.getDate() - 2);
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      this.date1 = dt.getDate() + " " + this.monthNames[fdMonth - 1];

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;

      return fd;
    },
    getDate5() {
      var dt = new Date();
      dt.setDate(dt.getDate() - 3);
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      this.date5 = dt.getDate() + " " + this.monthNames[fdMonth - 1];

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    getDate6() {
      var dt = new Date();
      dt.setDate(dt.getDate() + 3);
      var fdDate = dt.getDate();
      var fdMonth = dt.getMonth() + 1;
      var fdYear = dt.getFullYear();

      this.date6 = dt.getDate() + " " + this.monthNames[fdMonth - 1];

      if (fdMonth.toString().length == 1) {
        fdMonth = "0" + fdMonth;
      }
      if (fdDate.toString().length == 1) {
        fdDate = "0" + fdDate;
      }

      var fd = fdYear + "-" + fdMonth + "-" + fdDate;
      return fd;
    },
    hideModal() {
      this.$refs["mysearch-modal"].hide();
    },
    logout() {
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "langId = 1; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "lang = en; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      location.assign("/");
    },
    setLIDs() {
      this.setdateNtime(this.dateIden);
    },
    redirect() {
      if (this.value != undefined) {
        this.$router.push({ name: "Finished", params: { dateS: this.value } });
      }
    },

    numberCookie() {
      document.cookie =
        "number =" + this.number + ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
    },
    changeLang(value, value1) {
      this.setLang(value, value1);
      if (this.lang != undefined) {
        this.$i18n.locale = this.cookiesObject.lang;
        document.cookie = "lang =" + value;
        document.cookie = "langId =" + value1;

        if (this.cookiesObject.token) {
          var myHeaders = new Headers();
          myHeaders.append(
            "Cookie",
            "__cfduid=de50d5d8cce3ff6592c911352191001a61602584234"
          );

          var requestOptions = {
            method: "PUT",
            headers: myHeaders,
            redirect: "follow",
          };

          fetch(
            this.httpReq +
              "/user/language?languageId=" +
              (value1 ? value1 : 0) +
              "&token=" +
              this.cookiesObject.token,
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => console.log(result))
            .catch((error) => console.log("error", error))
            .then(
              setTimeout(function some() {
                location.reload();
              }, 500)
            );
        } else {
          location.reload();
        }
      }
    },

    async regSign() {
      var res = await fetch(
        this.httpReq +
          "/user/status?msisdn=" +
          this.results.formattedNumber.slice(1)
      );
      var data = await res.json();
      var regOrNot = data.code;

      this.regOrNot = regOrNot;

      if (regOrNot == 200) {
        var res1 = await fetch(
          this.httpReq +
            "/user/login/otp?msisdn=" +
            this.results.formattedNumber.slice(1),
          { method: "post" }
        );
        await res1.json();

        this.$refs["otp-modal2"].show();
      } else if (regOrNot == 404) {
        if (data.portals.length == 0) {
          this.errorText = "Number is not allowed for service";
          this.$refs["error-modal"].show();
        } else {
          if (this.cookiesObject.reg == 1) {
            var res2 = await fetch(
              this.httpReq +
                "/user/register/otp?msisdn=" +
                this.results.formattedNumber.slice(1) +
                "&portalId=" +
                data.portals[0].id,
              { method: "post" }
            );
            var dataresp = await res2.json();

            if (dataresp.code == 200) {
              if (this.cookiesObject.regText == 1) {
                this.$refs["regText-modal2"].show();
              } else {
                this.$refs["otp-modal2"].show();
              }
            } else if (dataresp.code == 405) {
              this.errorText = "Already registered";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // location.assign("/");
            } else if (dataresp.code == 404) {
              this.errorText = "Portal not found";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else if (dataresp.code == 500) {
              this.errorText = "Oops, something went wrong!";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else if (dataresp.code == 818) {
              this.errorText = "Subscription system error";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else if (dataresp.code == 408) {
              this.errorText = "Registration on this portal is disabled";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else {
              this.errorText = "Server error";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            }
          } else {
            this.$refs["regText2-modal"].show();
          }
        }
      }

      this.regOrNot = regOrNot;
    },

    async verify() {
      if (this.regOrNot == 404) {
        var res3 = await fetch(
          this.httpReq +
            "/user/register/verify?clientToken=" +
            this.clientToken +
            "&msisdn=" +
            this.results.formattedNumber.slice(1) +
            "&otp=" +
            this.OTP,
          { method: "post" }
        );
        var data3 = await res3.json();
        var token = data3.token;
        this.token = token;

        if (data3.code == 406) {
          this.errorText = "You entered Wrong OTP";
          this.$refs["error-modal"].show();
        } else if (data3.code == 500) {
          this.errorText = "Service error, try logging later";
          this.$refs["error-modal"].show();
        } else if (data3.code == 200) {
          document.cookie =
            "token =" +
            this.token +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

          var res13 = await fetch(
            this.httpReq + "/general/appData?token=" + this.token
          );
          var data13 = await res13.json();
          document.cookie =
            "portalId =" +
            data13.portal.id +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
          document.cookie = "countryCode =" + data13.portal.countryCode;

          this.reLoad();
        } else {
          alert(this.$t("LanguageEn.sError"));
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        }
      } else if (this.regOrNot == 200) {
        var res = await fetch(
          this.httpReq +
            "/user/login/verify?clientToken=" +
            this.clientToken +
            "&msisdn=" +
            this.results.formattedNumber.slice(1) +
            "&otp=" +
            this.OTP,
          { method: "post" }
        );
        var data = await res.json();
        var token1 = data.token;
        this.token = token1;

        if (data.code == 406) {
          this.errorText = "You entered Wrong OTP";
          this.$refs["error-modal"].show();
        } else if (data.code == 500) {
          this.errorText = "Service error, try logging later";
          this.$refs["error-modal"].show();
        } else if (data.code == 200) {
          document.cookie =
            "token =" +
            this.token +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

          var res12 = await fetch(
            this.httpReq + "/general/appData?token=" + this.token
          );
          var data12 = await res12.json();
          document.cookie =
            "portalId =" +
            data12.portal.id +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
          document.cookie = "countryCode =" + data12.portal.countryCode;

          this.reLoad();
        }
      } else {
        alert(this.$t("LanguageEn.sError"));
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      }
    },
    onUpdate(payload) {
      this.results = payload;
    },

    reLoad() {
      setTimeout(function some() {
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      }, 100);
    },
    async searchT(value) {
      const res = await fetch(
        this.httpReq +
          "/search?portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&query=" +
          value
      );
      const data = await res.json();
      const search = data.results;
      this.search = search;
      this.appear = true;
    },
  },
  components: {
    VuePhoneNumberInput,
  },
  props: {},
};
</script>

<style scoped>
#routerLink1 {
  padding-top: 12%;
  padding-left: 0px !important;
  display: inline-block;
  text-decoration: none;
  color: #e6e6e6;
  text-align: center !important;
}
#routerLink1 .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink1 .navbar-nav li > a:focus {
  color: #fff;
  font-weight: 550;
}

#routerLink1 .navbar-nav li.active > a.active {
  background-color: red;
  color: white;
}

.router-link-active {
  color: white;
  font-weight: bold;
}
.selectedLang {
  color: green;
  font-weight: bold;
}

.topNav {
  color: white !important;
  background: #1a1a1d !important;
  /* position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%; */
  height: 60px;
  line-height: 60px;
}
.MenuButton {
  color: white;
}
.loginButton {
  background: #1c5e20;
  border: none;
  /* margin-right: 10px; */
  color: #e6e6e6;
  float: right;
  border-radius: 2px;
  height: 30px;
}
.nav {
  justify-content: center;

  background: #1b5e20;
  height: 50px;
  justify-content: center;
}

#routerLink {
  display: inline-block;
  text-decoration: none;
  color: white;
  width: 50px;
  font-size: 12px;
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.2px;
}
#router-link,
#router-link:visited,
#router-link:active,
#router-link:focus {
  text-decoration: none;
  border: 0;
  outline: 0;
  color: #242424;
}

.middleSection {
  height: 50px;
}
.bb {
  color: #e6e6e6;
  font-size: 12px;
}

.MenuButton {
  background: none;
  height: 50px;
  border: none;
}
.b-sidebar-body {
  background: red;
}
</style>
<style>
#sidebar-profile .b-sidebar-header {
  background: #1b5e20;
  color: #e6e6e6;
  font-size: 16px;
}
#sidebar-profile .b-sidebar-header .close {
  color: #e6e6e6;
}
#sidebar-profile .b-sidebar-body {
  background: #1a1a1d;
  color: #e6e6e6;
}
#sidebar-1 .b-sidebar-header {
  background: #1a1a1d;
  color: #e6e6e6;
  font-size: 16px;
}
#sidebar-1 .b-sidebar-header .close {
  color: #e6e6e6;
}
#sidebar-1 .b-sidebar-body {
  background: #1a1a1d;
  color: #e6e6e6;
}
</style>